export default __webpack_public_path__ + "img/tremors/tremors9_1500.webp";